document.addEventListener("DOMContentLoaded", () => {
    let slider = document.querySelector('.slider');
    if (slider) {
        let objectSlider = new HomepageSlider(slider);
        objectSlider.init();
    }
});

class HomepageSlider {
    constructor(slider) {
        this.slider = slider;
        this.slides = slider.querySelectorAll('.slider__item');
        this.wrap = slider.querySelector('.slider__wrap');
        this.countSlides = this.slides.length;
        this.slideIndex = 0;
    }

    init() {
        if (this.countSlides > 1) {
            let firstCloned = this.slides[0].cloneNode(true);
            this.wrap.appendChild(firstCloned);
            let that = this;
            setInterval(() => {
                this.slideIndex++;
                this.wrap.classList.remove('no-transition');
                that.slide();
            }, 5000);
        }
    }

    slide() {
        this.wrap.style.left = (this.slideIndex * -100) + '%';
        let that = this;
        setTimeout(function () {
            if (that.slideIndex >= that.countSlides) {
                that.wrap.classList.add('no-transition');
                that.slideIndex = 0;
                that.slide();
            }
        }, 400);

    }
}
